import MiniGameImages from "../MiniGameImages";

export default class ClassicQuizOptionModel {
  public optionId: number = null;
  public option: string = null;
  public images: MiniGameImages = null;
  public correct: boolean = null;
}
